import { _UserData, UserDataBaseEnum } from 'base/src/infra/storage/localStorage';
import Avatar from 'base/src/components/Avatar';

import * as S from './styles'

import { Tag } from 'base/src/components/Tag';
import { CampanhaPedidoResgateResponse } from 'domain/types/_carteira/campanhaPedidoResgate/campanhaPedidoResgateResponse';

import { useCallback, useEffect, useState } from 'react';

import StateMensage from 'base/src/view/states/state';

import { Button } from 'base/src/components/Button';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { ModalTrigger } from 'base/src/components/Modal';
import { CAMPANHARESGATE_APROVAR } from 'domain/types/_carteira/campanhaPedidoResgate/campanhaPedidoResgate';
import { CampanhaUsuarioResponse } from '../../../../types/campanhaUsuario/campanhaUsuarioResponse';
import { CampanhaPedidoExtratoResponse } from '../../../../types/campanhaPedidoExtrato/campanhaPedidoExtratoResponse';
import { UltimaOperacaoResponse } from '../../../../types/aprovarPedido/ultimaOperacaoResponse';
import AprovarPedidoDetalhesContainer from '../../../../containers/aprovarPedido/aprovarPedidoDetalhes/aprovarPedidoDetalhesContainer';
import { RootStateCampanha } from '../../../../store/campanhaReducer';
import { AprovarResgate } from '../../../../store/aprovarPedido/actions/aprovarPedidoAction';
import { GetByUsuarioCampanha, GetResumoCampanha } from '../../../../store/produtos/action/produtoAction';
import { Tabs, TabsContent } from 'base/src/components/Tabs';
import { TabPedido } from './components/TabPedido';
import TabResumo from './components/TabResumo';
import TabHistorico from './components/TabHistorico';
import StringUtil from 'domain/utils/StringUtils';
import { TabExtrato } from './components/TabExtrato';
import moment from 'moment';

const statusNomeMap: Record<number, string> = {
  1: 'Solicitado',
  2: 'Aprovado',
  3: 'Não Aprovada',
  4: 'Pago/Entregue',
  5: 'Em Espera',
  6: 'Cancelado',
  7: 'Lote Alocado',
  8: 'Erro no Pagamento',
};

const connector = connectUtil(
  (_state: RootStateCampanha) => ({
    CarteiraUsuarioInfo: _state.CarteiraBaseReducer.CarteiraUsuario,
  }),
  { AprovarResgate, GetByUsuarioCampanha, GetResumoCampanha }
);

export interface AprovarPedidoDetalhesProps extends PropsFromRedux<typeof connector> {
  campanhaPedidoResgate: CampanhaPedidoResgateResponse;
  onClose: () => void;
}

function AprovarPedidoDetalhes(props: AprovarPedidoDetalhesProps) {
  const _aprovarPedidoContainer = new AprovarPedidoDetalhesContainer(props)

  console.log('campanhaPedidoResgate', props.campanhaPedidoResgate.Premiacao.PremiacaoTipo.PremiacaoTipoID);

  const [status, setStatus] = useState<number>(0);
  const [motivo, setMotivo] = useState<string>('');
  const [campanhaUsuario, setCampanhaUsuario] = useState<CampanhaUsuarioResponse | null>(null);
  const [campanhaPedidoExtrato, setCampanhaPedidoExtrato] = useState<CampanhaPedidoExtratoResponse[]>([]);
  const [activeTab, setActiveTab] = useState<string>('pedido');
  const [ultimaOperacao, setUltimaOperacao] = useState<UltimaOperacaoResponse | null>(null);

  useEffect(() => {
    if (props.campanhaPedidoResgate.Premiacao.Campanha.CampanhaID) {
      // Buscar dados do usuário na campanha
      _aprovarPedidoContainer.GetCampanhaUsuario(props.campanhaPedidoResgate._Usuario.UsuarioID, props.campanhaPedidoResgate.Premiacao.Campanha.CampanhaID).then((response) => {
        setCampanhaUsuario(response);
      });

      // Buscar extrato do usuário na campanha
      _aprovarPedidoContainer.GetCampanhaPedidoExtrato(props.campanhaPedidoResgate._Usuario.UsuarioID, props.campanhaPedidoResgate.Premiacao.Campanha.CampanhaID).then((response) => {
        setCampanhaPedidoExtrato(response);
      });

      // Buscar última operação do resgate
      _aprovarPedidoContainer.GetUltimaOperacao(props.campanhaPedidoResgate.CampanhaPedidoResgateID).then((response) => {
        if (response) setUltimaOperacao(response);
      });

      // Buscar histórico de produtos
      props.GetByUsuarioCampanha(
        props.campanhaPedidoResgate._Usuario.UsuarioID,
        props.campanhaPedidoResgate.Premiacao.Campanha.CampanhaID,
        () => { }
      );
      // Buscar resumo da campanha
      props.GetResumoCampanha(
        props.campanhaPedidoResgate._Usuario.UsuarioID,
        props.campanhaPedidoResgate.Premiacao.Campanha.CampanhaID,
        props.campanhaPedidoResgate.CampanhaPedidoResgateID,
        () => { }
      );
    }
  }, [props.campanhaPedidoResgate]);

  const _userData = _UserData;

  const invalidTransitions = new Set([
    "1-1", "1-4", "1-5", "1-7", "1-8",
    "2-2", "2-4", "2-5", "2-7", "2-8",
    "3-1", "3-2", "3-3", "3-4", "3-5", "3-6", "3-7", "3-8",
    "4-1", "4-2", "4-3", "4-4", "4-5", "4-6", "4-7", "4-8",
    "5-1", "5-2", "5-3", "5-4", "5-5", "5-6", "5-7", "5-8",
    "6-1", "6-2", "6-3", "6-4", "6-5", "6-6", "6-7", "6-8",
    "7-1", "7-2", "7-3", "7-4", "7-5", "7-6", "7-7", "7-8",
    "8-1", "8-2", "8-3", "8-4", "8-5", "8-6", "8-7", "8-8"
  ]);

  function getFilteredOptions(currentStatus: number) {
    if (props.campanhaPedidoResgate.Premiacao.PremiacaoTipo.PremiacaoTipoID === 1) {
      return [
        {
          nomeGrupo: "Selecionar status",
          options: [
            { id: 2, nome: "Aprovado" },
          ].filter(opt => !invalidTransitions.has(`${currentStatus}-${opt.id}`))
        }
      ];
    }

    return [
      {
        nomeGrupo: "Selecionar status",
        options: [
          { id: 1, nome: "Solicitado" },
          { id: 2, nome: "Aprovado" },
          { id: 3, nome: "Não Aprovada" },
          { id: 4, nome: "Pago/Entregue" },
          { id: 5, nome: "Em Espera" },
          // { id: 6, nome: "Cancelado" },
          { id: 7, nome: "Lote Alocado" },
          { id: 8, nome: "Erro no Pagamento" },
        ].filter(opt => !invalidTransitions.has(`${currentStatus}-${opt.id}`))
      }
    ];
  }

  const handleChangeStatus = useCallback(
    async () => {
      await props.AprovarResgate(
        props.campanhaPedidoResgate.CampanhaPedidoResgateID,
        props.campanhaPedidoResgate.CampanhaPedidoResgateStatusID,
        Number(status),
        motivo
      );

      // Limpar estado antes de fechar
      setStatus(0);
      setMotivo('');
      setActiveTab('pedido');

      props.onClose();
    },
    [props.campanhaPedidoResgate, _userData, props.AprovarResgate, status, motivo, props.onClose]
  );

  const filteredOpts = getFilteredOptions(props.campanhaPedidoResgate.CampanhaPedidoResgateStatusID);


  function optionOnChange(v: string) {
    setStatus(Number(v))
  }


  function handleClose() {
    // Limpar qualquer estado local antes de fechar
    setStatus(0);
    setMotivo('');
    setActiveTab('pedido');

    // Chamar a função de fechamento da modal
    props.onClose();
  }

  const statusA = props.campanhaPedidoResgate.CampanhaPedidoResgateStatus;

  const statusID = statusA?.CampanhaPedidoResgateStatusID;

  console.log('filteredOpts', filteredOpts);

  return (
    <S.Container>
      <S.ScrollableContent>
        <S.Title>Resgate</S.Title>
        <S.AvatarContainer>
          {props.campanhaPedidoResgate.CampanhaPedidoResgateStatus &&
            <Tag
              variant={
                statusID === 1 || statusID === 5
                  ? 'warning'
                  : statusID === 2 || statusID === 4
                    ? 'positive'
                    : statusID === 3 || statusID === 6
                      ? 'danger'
                      : 'positive'
              }
            >
              {props.campanhaPedidoResgate.CampanhaPedidoResgateStatus.Titulo}
            </Tag>
          }

          <S.ProfileInfo>
            <Avatar size='md' alt='userPedidoAvatar' fallBack={StringUtil.GetFirstLetters(props.campanhaPedidoResgate._Usuario.NomeCompleto)} borderColor='transparent' src={props.campanhaPedidoResgate._Usuario.ImagemUrl} />
            <S.TextCotainer>
              <S.Title>{props.campanhaPedidoResgate._Usuario.NomeCompleto}</S.Title>
              {campanhaUsuario?.EmAnalise && (
                <div style={{ marginTop: 5 }}>
                  <Tag variant='danger'>
                    Usuário Suspeito
                  </Tag>
                </div>
              )}
            </S.TextCotainer>
          </S.ProfileInfo>
        </S.AvatarContainer>
        <S.StatusSection>
          <S.StatusHeader>
            {
              statusID === 1 ?
                <S.StatusTitle>Este resgate ainda não passou por aprovação. Selecione um status:</S.StatusTitle>
                :
                statusID === 5 ?
                  <S.StatusTitle>Este resgate está em espera do processamento...</S.StatusTitle>
                  :
                  <S.StatusTitle>Mude o status do resgate:</S.StatusTitle>
            }
          </S.StatusHeader>
          {
            statusID !== 5 && (
              filteredOpts[0].options.length > 0 ? (
                <S.StatusButtonGrid>
                  {filteredOpts[0].options.map((option) => (
                    <S.StatusButton
                      key={option.id}
                      onClick={() => setStatus(option.id)}
                      isSelected={status === option.id}
                      statusType={
                        option.id === 1 || option.id === 5
                          ? 'warning'
                          : option.id === 2 || option.id === 4
                            ? 'positive'
                            : option.id === 3 || option.id === 6
                              ? 'danger'
                              : 'neutral'
                      }
                    >
                      {option.nome}
                    </S.StatusButton>
                  ))}
                </S.StatusButtonGrid>
              ) : (
                <S.StatusMessage>Não é possível mudar status</S.StatusMessage>
              )
            )
          }
        </S.StatusSection>

        {/* Motivo de Reprovação */}
        {status === 3 && (
          <S.MotivoSection>
            <S.MotivoLabel>Motivo da Reprovação *</S.MotivoLabel>
            <S.MotivoTextarea
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
              placeholder="Digite o motivo da reprovação..."
              rows={3}
            />
          </S.MotivoSection>
        )}

        {/* Informações do Usuário */}
        <S.UserInfoHeader>
          {campanhaUsuario?.EmAnalise ? (
            <Tag variant='danger'>
              ⚠️ Usuário marcado como suspeito
            </Tag>
          ) : campanhaUsuario && (
            <Tag variant='positive'>
              ✓ Usuário com perfil regular
            </Tag>
          )}
        </S.UserInfoHeader>

        {/* Última Operação */}
        {ultimaOperacao && (
          <S.UltimaOperacaoSection>
            <S.UltimaOperacaoTitle>Última alteração de status</S.UltimaOperacaoTitle>
            <S.UltimaOperacaoCard>
              <S.UltimaOperacaoRow>
                <S.UltimaOperacaoLabel>Usuário</S.UltimaOperacaoLabel>
                <S.UltimaOperacaoValue>{ultimaOperacao.Usuario}</S.UltimaOperacaoValue>
              </S.UltimaOperacaoRow>

              <S.UltimaOperacaoRow>
                <S.UltimaOperacaoLabel>Status alterado para</S.UltimaOperacaoLabel>
                <S.ExtratoStatusTag statusId={ultimaOperacao.CampanhaPedidoResgateStatusID}>
                  {statusNomeMap[ultimaOperacao.CampanhaPedidoResgateStatusID] ?? `Status ${ultimaOperacao.CampanhaPedidoResgateStatusID}`}
                </S.ExtratoStatusTag>
              </S.UltimaOperacaoRow>
              {ultimaOperacao.CampanhaPedidoResgateStatusID_Anterior && (
                <S.UltimaOperacaoRow>
                  <S.UltimaOperacaoLabel>Status anterior</S.UltimaOperacaoLabel>
                  <S.ExtratoStatusTag statusId={ultimaOperacao.CampanhaPedidoResgateStatusID_Anterior}>
                    {statusNomeMap[ultimaOperacao.CampanhaPedidoResgateStatusID_Anterior] ?? `Status ${ultimaOperacao.CampanhaPedidoResgateStatusID_Anterior}`}
                  </S.ExtratoStatusTag>
                </S.UltimaOperacaoRow>
              )}
              <S.UltimaOperacaoRow>
                <S.UltimaOperacaoLabel>Data</S.UltimaOperacaoLabel>
                <S.UltimaOperacaoValue>{moment(ultimaOperacao.AtualizadoEm).format('DD/MM/YYYY HH:mm')}</S.UltimaOperacaoValue>
              </S.UltimaOperacaoRow>
            </S.UltimaOperacaoCard>
          </S.UltimaOperacaoSection>
        )}

        {/* Tabs */}
        <Tabs
          items={[
            { value: 'pedido', label: 'Pedido' },
            { value: 'resumo', label: 'Resumo' },
            { value: 'extrato', label: 'Extrato' },
            { value: 'historico', label: 'Histórico' }
          ]}
          defaultValue="pedido"
          onValueChange={setActiveTab}
        >
          <TabsContent value="pedido">
            <TabPedido campanhaPedidoResgate={props.campanhaPedidoResgate} />
          </TabsContent>

          <TabsContent value="resumo">
            <TabResumo />
          </TabsContent>

          <TabsContent value="extrato">
            <TabExtrato
              campanhaPedidoExtrato={campanhaPedidoExtrato}
              campanhaId={props.CarteiraUsuarioInfo[0].CarteiraID}
            />
          </TabsContent>

          <TabsContent value="historico">
            <TabHistorico />
          </TabsContent>
        </Tabs>
      </S.ScrollableContent>

      <S.FixedFooter>
        <ModalTrigger asChild>
          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 10 }}>
            <Button full variant='secondary' size='md' onClick={handleClose}>Cancelar</Button>
            <Button full variant='primary' size='md' disabled={status === 0 || (status === 3 && motivo.trim() === '')} onClick={handleChangeStatus}>Salvar</Button>
          </div>
        </ModalTrigger>
        <StateMensage stateLoadingNames={[CAMPANHARESGATE_APROVAR]} stateErrorNames={[CAMPANHARESGATE_APROVAR]} />
      </S.FixedFooter>
    </S.Container>
  )
}

export default connector(AprovarPedidoDetalhes);